import { combineReducers } from 'redux';

//Model
import UserReducer from './model/user';
import VersionReducer from './model/version';
import ModalYoutubeManualReducer from './model/modalPopup';
import AccountServiceReducer from './model/accountService';

// Common
import RoutesReducer from './common/routes';
import SearchbarReducer from './common/searchbar';
import TutorialReducer from './common/tutorial';
import YoutubeReducer from './common/youtube';

const rootReducer = combineReducers({
  //Model
  UserReducer,
  VersionReducer,
  ModalYoutubeManualReducer,
  AccountServiceReducer,

  // Common
  RoutesReducer,
  SearchbarReducer,
  TutorialReducer,
  YoutubeReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
